<section class="bg-white p-6">
  <!-- title -->
  <h1 class="text-xl font-bold text-dc-navy mb-6 border-b border-gray-300 pb-3">
    {{ "HEADER.RESOURCES" | translate }}
  </h1>

  <!-- filters -->
  <form class="flex flex-wrap gap-4 mb-8" [formGroup]="form">
    <app-option-field
      class="w-48"
      [placeholder]="'MANUALS.CAT.PH' | translate"
      [control]="form.get('category')"
      [options]="resourceCategoriesList"
      [labelKey]="'label'"
      [valueKey]="'value'"
    ></app-option-field>

    <div class="ms-auto w-full sm:w-64">
      <div class="flex items-center border border-gray-300 overflow-hidden">
        <input
          type="text"
          [placeholder]="'MANUALS.SEARCH.PLH' | translate"
          class="flex-grow px-4 py-2 text-sm focus:outline-none"
          formControlName="search"
        />
        <button type="button" class="px-4 text-dc-navy">
          <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
  </form>

  <!-- card grid -->
  @if (filtered$ | async; as resources) {
  <div class="w-full md:w-[80%]">
    <div class="grid gap-6 md:grid-cols-2 items-stretch">
      @for (c of resources; track c.titleEn) {
      <div class="border border-dc-navy p-6 relative flex flex-col h-full min-h-[190px]">
        <h2
          class="text-dc-navy text-lg font-semibold underline cursor-pointer underline-offset-4"
          (click)="open(c)"
        >
          {{ lang === "ar" ? c.titleAr : c.titleEn }}
        </h2>
        <p class="text-sm text-dc-navy! mt-3 flex-1">
          {{ lang === "ar" ? c.descriptionAr : c.descriptionEn }}
        </p>
        <a
          class="text-sm font-semibold mt-4 inline-flex items-center gap-1 text-dc-navy!"
          [href]="lang === 'ar' ? c.URL_AR : c.URL_EN"
          target="_blank"
          rel="noopener noreferrer"
          (click)="open(c); $event.preventDefault()"
        >
          {{ "MANUALS.SEE" | translate }}
          {{ lang === "ar" ? c.categoryAr : c.categoryEn }}
          <img src="/icons/svg/arrow-right.svg" class="transition-transform rtl:rotate-180" />
        </a>
        <!-- corner accent -->
        <span
          class="dc-card-corner-blue "
        ></span>
      </div>
      }
    </div>
  </div>
  }
</section>
